import Sidemenu from "./dev/js/sidemenu";
import Form from "./dev/js/form";

'use strict';

( function ( $, w ) {

    var $window = $( w );

    $window.on( 'elementor/frontend/init', function() {

        // ---------------------------------------
        // - Fixed Side Menu
        new Sidemenu();
        // ---------------------------------------


        // ---------------------------------------
        // translate calendar and set date format
        new Form();
        // ---------------------------------------
    });

} ( jQuery, window ) );